import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { GenFormBuilder } from "../../providers/form";
import { Utilities } from "../../providers/utilities";

@Component({
  selector: "app-days-availability-form",
  templateUrl: "days-availability-form.html",
})
export class DaysAvailabilityFormComponent {

  @Input() public daysAvailability: any[] = [];
  @Output() public emitDayAvailability = new EventEmitter();

  public form: FormGroup;
  public isForm = false;
  public inputTypeChange = false;
  public currentDayAvailability = null;
  public submitAttempt = false;

  constructor(
    public utilities: Utilities,
    private formBuilder: FormBuilder,
    private formGenerate: GenFormBuilder,
  ) { }

  public addOrUpdate(current = null) {
    const load = this.utilities.setLoading();

    this.buildForm(current);

    return Promise.resolve()
      .then(() => {
        if (current) {
          this.currentDayAvailability = current;
        } else {
          this.currentDayAvailability = null;
        }
        return true;
      })
      .then(() => this.isForm = true)
      .then(() => load.dismiss());
  }

  public createOrUpdate({ value, valid }) {
    this.submitAttempt = true;
    if (valid) {
      const load = this.utilities.setLoading();

      return Promise.resolve()
        .then(() => this.emitDayAvailability.emit(value))
        .then(() => this.isForm = false)
        .then(() => load.dismiss());
    } else {
      this.utilities.consoleError("Form", this.form);
      this.utilities.setToast("Form contain errors", 3000, "top");
    }
  }

  private buildForm(info = null) {
    this.submitAttempt = false;

    this.form = this.formBuilder.group({});
    this.formGenerate.genInputString("id", this.form, false);
    this.formGenerate.genInputString("day", this.form, true);
    this.formGenerate.genInputString("hourStart", this.form, true);
    this.formGenerate.genInputString("hourEnd", this.form, true);
    this.formGenerate.genToggle("state", this.form, false, true);

    if (info) {
      this.form.patchValue(info);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/days-availability-form/days-availability-form.ts